import { Form } from "antd";

import { useSetVendorUsers } from "data/use-vendors";
import { UserSelect } from "components/selects/user-select";
import { useOnChange } from "hooks/use-on-change";
import { Modal } from "components/modal";

export const SetUsers = ({ close, isOpen, vendor }) => {
  const setVendorUsers = useSetVendorUsers({
    onSuccess: close,
  });

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setVendorUsers.mutate({
      id: vendor._id,
      userIds: values.userIds,
    });
  };

  useOnChange(
    isOpen,
    () => {
      if (!isOpen) {
        return;
      }

      form.setFieldsValue({
        userIds: vendor.users,
      });
    },
    [isOpen, form, vendor]
  );

  return (
    <Modal
      confirmLoading={setVendorUsers.isLoading}
      okText="Set Sales Reps"
      onCancel={close}
      onOk={form.submit}
      open={isOpen}
      title="Sales Reps"
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        onFinish={onFinish}
      >
        <UserSelect
          label="Sales Reps"
          mode="multiple"
          name="userIds"
          placeholder="Select sales reps"
        />
      </Form>
    </Modal>
  );
};
